<template>
  <v-card
    style="flex: 1; margin-top: 10px; margin-left: 10px; margin-right: 5px"
  >
    <div style="display: flex; margin-top: 10px">
      <div style="flex: 1">
        <span class="titledashboard">{{ $t("_nombre_de_site_") }}</span>
        <div
          style="
            margin-left: 10px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 10px;
          "
        >
          <span
            style="
              font-size: 30px;
              font-weight: bold;
              margin-top: 5px;
              margin-bottom: 5px;
            "
            >{{ liste_dashboard.nb_de_site }}</span
          >
        </div>
      </div>

      <div class="containerdashboard">
        <span class="titledashboard">{{ $t("_pr_parc_") }}</span>
        <div style="margin-left: 10px; display: flex; margin-top: 10px">
          <div>
            <div
              ref="myChartContainer1"
              style="width: 100%; margin: auto; max-width: 125px"
            ></div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 8px; margin-bottom: -10px">
              <span style="font-size: 18px"
                >{{ liste_dashboard.pr_clean_parc_evo }}%</span
              >
              <v-icon
                v-if="liste_dashboard.pr_clean_parc_evo >= 0"
                color="#12D600"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-top-right</v-icon
              >
              <v-icon
                v-if="
                  liste_dashboard.pr_clean_parc_evo < 0 &&
                  liste_dashboard.pr_clean_parc_evo >= -2
                "
                color="orange"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-bottom-right</v-icon
              >
              <v-icon
                v-if="liste_dashboard.pr_clean_parc_evo < -2"
                color="#FA4C4C"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-bottom-right</v-icon
              >
            </div>
            <div>
              <span style="font-size: 12px">{{ $t("_evolutions_") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="containerdashboardtwo"
        @click="toggleMenu"
        style="cursor: pointer"
      >
        <span class="titledashboard">{{
          $t("_pertes_vs_modele_energie_")
        }}</span>
        <div
          style="
            margin-left: 10px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 10px;
            gap: 20px;
          "
        >
          <span
            style="
              font-size: 27px;
              font-weight: bold;
              margin-top: 5px;
              margin-bottom: 5px;
            "
            >{{ liste_dashboard.pertes_vs_modele_energie }} %</span
          >
          <div style="display: flex; align-items: center">
            <div>
              <div ref="myChartContainer3" class="graph"></div>
            </div>
            <div style="flex: 1; margin-left: -10px">
              <div style="margin-top: 8px; margin-bottom: -10px">
                <span style="font-size: 18px"
                  >{{ liste_dashboard.pertes_vs_modele_energie_evo }} %</span
                >
                <v-icon
                  v-if="liste_dashboard.pertes_vs_modele_energie_evo > 2"
                  color="#FA4C4C"
                  style="margin-left: 5px; margin-bottom: 3px"
                  >mdi-arrow-top-right</v-icon
                >
                <v-icon
                  v-if="
                    liste_dashboard.pertes_vs_modele_energie_evo > 0 &&
                    liste_dashboard.pertes_vs_modele_energie_evo <= 2
                  "
                  color="orange"
                  style="margin-left: 5px; margin-bottom: 3px"
                  >mdi-arrow-top-right</v-icon
                >
                <v-icon
                  v-if="liste_dashboard.pertes_vs_modele_energie_evo < 0"
                  color="#12D600"
                  style="margin-left: 5px; margin-bottom: 3px"
                  >mdi-arrow-bottom-right</v-icon
                >
              </div>
              <div>
                <span style="font-size: 12px">{{ $t("_evolutions_") }}</span>
              </div>
            </div>
          </div>
        </div>
        <v-menu
          v-model="menuVisible"
          offset-y
          class="custom-nudge"
          transition="scale-transition"
          attach
        >
          <v-card>
            <v-treeview
              v-if="alarmLossTree !== undefined"
              :items="alarmLossTree"
              :transition="true"
              open-on-click
              dense
            >
              <template v-slot:label="{ item }">
                <span v-if="item.level == 0" v-bind:style="'color: #000000'">
                  {{ $t(item.name) }}
                </span>

                <span
                  v-else-if="item.level == 1"
                  v-bind:style="'color: rgba(0,0,0,.6)'"
                >
                  {{ $t(item.name) }}
                </span>
              </template>

              <template v-slot:append="{ item }">
                <span
                  v-if="item.level == 0"
                  v-bind:style="'color: #000000; padding-left: 10px;'"
                >
                  <b>{{ String(item.loss_value_rounded) + " %" }}</b>
                </span>

                <span
                  v-else-if="item.level == 1"
                  v-bind:style="'color: rgba(0,0,0,.6); padding-left: 10px;'"
                >
                  <b>{{ String(item.loss_value_rounded) + " %" }}</b>
                </span>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <div class="containerdashboardtwo">
        <span class="titledashboard" style="font-size: 15px">{{
          $t("_info_alarmes_")
        }}</span>
        <div class="dashboard-content">
          <div class="icon-container">
            <div class="icon-item">
              <v-icon color="#44FF79" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_sites_sans_alarmes_") }}: {{ this.total }}</span
              >
            </div>
            <div class="icon-item">
              <v-icon color="#FFA500" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_alarmes_severe_") }}: {{ this.minor_alarms }}</span
              >
            </div>
            <div class="icon-item">
              <v-icon color="#FA4C4C" small>mdi-circle</v-icon>
              <span class="icon-label"
                >{{ $t("_alarmes_critique_") }}: {{ this.major_alarms }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; margin-top: 20px; margin-bottom: 10px">
      <div style="flex: 1">
        <span class="titledashboard">{{ $t("_puissance_crete_(mwc)_") }}</span>
        <div
          style="
            margin-left: 10px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin-bottom: 15px;
          "
        >
          <span
            style="
              font-size: 30px;
              font-weight: bold;
              margin-top: 5px;
              margin-bottom: 5px;
            "
          >
            {{ liste_dashboard.pc_totale.toFixed(1) }}
            <span style="font-weight: normal">{{ $t("_mwc_") }}</span>
          </span>
        </div>
      </div>

      <div class="containerdashboard">
        <span class="titledashboard">{{ $t("_disponibilite_parc_") }}</span>
        <div style="display: flex; align-items: center">
          <div>
            <div ref="myChartContainer3" class="graph"></div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 8px; margin-bottom: -10px">
              <span style="font-size: 18px"
                >{{ liste_dashboard.disponibilite_parc_evo }} %</span
              >
              <v-icon
                v-if="liste_dashboard.disponibilite_parc_evo >= 0"
                color="#12D600"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-top-right</v-icon
              >
              <v-icon
                v-if="
                  liste_dashboard.disponibilite_parc_evo < 0 &&
                  liste_dashboard.disponibilite_parc_evo >= -2
                "
                color="orange"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-bottom-right</v-icon
              >
              <v-icon
                v-if="liste_dashboard.disponibilite_parc_evo < -2"
                color="#FA4C4C"
                style="margin-left: 5px; margin-bottom: 3px"
                >mdi-arrow-bottom-right</v-icon
              >
            </div>
            <div>
              <span style="font-size: 12px">{{ $t("_evolutions_") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="containerdashboardtwo"
        @click="toggleMenuAction"
        style="cursor: pointer"
      >
        <span class="titledashboard">{{ $t("_pertes_recouvrables_") }}</span>
        <div>
          <div
            style="
              margin-left: 10px;
              justify-content: center;
              display: flex;
              align-items: center;
              margin-top: 10px;
              gap: 20px;
            "
          >
            <span
              style="
                font-size: 22px;
                font-weight: bold;
                margin-top: 10px;
                margin-bottom: 5px;
              "
              >{{ liste_dashboard.pertes_recouvrables }}%</span
            >
          </div>
        </div>
        <v-menu
          v-model="menuVisibleAction"
          offset-y
          class="custom-nudge"
          transition="scale-transition"
          attach
        >
          <v-card>
            <v-treeview
              v-if="actionLossTree"
              :items="actionLossTree"
              :transition="true"
              open-on-click
              dense
            >
              <template v-slot:label="{ item }">
                <span v-if="item.level == 0" v-bind:style="'color: #000000'">
                  {{ $t(item.name) }}
                </span>
                <span
                  v-else-if="item.level == 1"
                  v-bind:style="'color: rgba(0,0,0,.6)'"
                >
                  {{ $t(item.name) }}
                </span>
              </template>
              <template v-slot:append="{ item }">
                <span
                  v-if="item.level == 0"
                  v-bind:style="'color: #000000; padding-left: 10px;'"
                >
                  <b>{{ String(item.loss_value_rounded) + " %" }}</b>
                </span>
                <span
                  v-else-if="item.level == 1"
                  v-bind:style="'color: rgba(0,0,0,.6); padding-left: 10px;'"
                >
                  <b>{{ String(item.loss_value_rounded) + " %" }}</b>
                </span>
              </template>
            </v-treeview>
          </v-card>
        </v-menu>
      </div>

      <div class="containerdashboardtwo">
        <div
          ref="myChartContainer6"
          style="
            width: 100%;
            max-width: 150px;
            margin-bottom: 5px;
            margin-left: 20%;
            margin-top: 5%;
          "
        ></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    liste_dashboard: {
      type: Object,
      required: true,
    },
    alarmsByInstallation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartpr: null,
      menuVisible: false,
      menuVisibleAction: false,
      menuStyle: {},
      alarmLossTree: null,
      actionLossTree: null,
      total: 0,
      major_alarms: 0,
      minor_alarms: 0,
    };
  },

  computed: {
    calculatedNudge() {
      return window.innerWidth * 0.5;
    },
  },

  mounted() {
    this.createChart();

    this.createbluechart();
    this.$nextTick(() => {
      this.updateChart();
      // Force an update after the DOM has rendered
    });
  },

  watch: {
    liste_dashboard: {
      handler(newVal) {
        this.alarmLossTree = newVal.waterfall;
        this.actionLossTree = newVal.actionable_waterfall;
        this.updateChart();
      },
      immediate: true,
    },
    alarmsByInstallation: {
      handler(newVal) {
        this.major_alarms = newVal.major_alarms;
        this.minor_alarms = newVal.minor_alarms;
        this.total = newVal.no_alarm_found;
        this.updateChart();
      },
      immediate: true,
    },
  },

  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    toggleMenuAction() {
      this.menuVisibleAction = !this.menuVisibleAction;
    },

    createChart() {
      const ctx1 = document.createElement("canvas");
      this.$refs.myChartContainer1.appendChild(ctx1);

      const ctx6 = document.createElement("canvas");
      this.$refs.myChartContainer6.appendChild(ctx6);

      const yValues = [35, 35, 30];
      const yValues1 = [40, 60];
      const barColors = ["#44FF79", "#FFA500", "#FA4C4C"];
      const barColors1 = ["#12D600", "#ffffff"];

      this.chartpr = new Chart(ctx1, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors1,
              borderWidth: 0,
              data: yValues1,
            },
          ],
        },
        options: {
          cutoutPercentage: 75,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });

      this.chartalarmes = new Chart(ctx6, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors,
              borderWidth: 0,
              data: yValues,
            },
          ],
        },
        options: {
          cutoutPercentage: 75,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });

      this.addCenterCircleAndTextgreen(
        this.$refs.myChartContainer1,
        this.liste_dashboard.pr_clean_parc
      );
    },

    createbluechart() {
      const ctx3 = document.createElement("canvas");
      this.$refs.myChartContainer3.appendChild(ctx3);

      const yValues = [90, 10];
      const barColors = ["#344BFD", "#ffffff"];

      this.chartdisponibilite = new Chart(ctx3, {
        type: "doughnut",
        data: {
          datasets: [
            {
              backgroundColor: barColors,
              borderWidth: 0,
              data: yValues,
            },
          ],
        },
        options: {
          cutoutPercentage: 90,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
        },
      });
      this.addCenterCircleAndText(this.$refs.myChartContainer3, "NA%");
    },

    addCenterCircleAndText(container, percentage) {
      const blueCircle = document.createElement("div");
      blueCircle.style.position = "absolute";
      blueCircle.style.top = "51%";
      blueCircle.style.left = "50%";
      blueCircle.style.transform = "translate(-50%, -50%)";
      blueCircle.style.width = "50px";
      blueCircle.style.height = "50px";
      blueCircle.style.backgroundColor = "#BDEAFF";
      blueCircle.style.borderRadius = "50%";
      blueCircle.style.pointerEvents = "none";

      const centerText = document.createElement("div");
      if (typeof percentage === "number") {
        centerText.innerText = `${percentage.toFixed(1)}%`;
      } else {
        centerText.innerText = percentage;
      }

      centerText.style.position = "absolute";
      centerText.style.top = "53%";
      centerText.style.left = "52%";
      centerText.style.transform = "translate(-50%, -50%)";
      centerText.style.fontSize = "14px";
      centerText.style.fontWeight = "bold";
      centerText.style.color = "black";
      centerText.style.pointerEvents = "none";
      container.style.position = "relative";

      container.appendChild(blueCircle);
      container.appendChild(centerText);
    },

    addCenterCircleAndTextgreen(container, percentage) {
      const blueCircle = document.createElement("div");
      blueCircle.style.position = "absolute";
      blueCircle.style.top = "50%";
      blueCircle.style.left = "50%";
      blueCircle.style.transform = "translate(-50%, -50%)";
      blueCircle.style.width = "51px";
      blueCircle.style.height = "51px";
      blueCircle.style.backgroundColor = "#C2FFBC";
      blueCircle.style.borderRadius = "50%";
      blueCircle.style.pointerEvents = "none";

      const centerText = document.createElement("div");
      if (typeof percentage === "number") {
        centerText.innerText = `${percentage.toFixed(0)}%`;
      } else {
        centerText.innerText = percentage;
      }

      centerText.style.position = "absolute";
      centerText.style.top = "53%";
      centerText.style.left = "52%";
      centerText.style.transform = "translate(-50%, -50%)";
      centerText.style.fontSize = "14px";
      centerText.style.fontWeight = "bold";
      centerText.style.color = "black";
      centerText.style.pointerEvents = "none";
      container.style.position = "relative";

      container.appendChild(blueCircle);
      container.appendChild(centerText);
    },

    updateChart() {
      // Update the availability chart
      if (this.chartdisponibilite) {
        this.chartdisponibilite.data.datasets[0].data[0] =
          this.liste_dashboard.disponibilite_parc;
        this.chartdisponibilite.data.datasets[0].data[1] =
          100 - this.liste_dashboard.disponibilite_parc;
        this.chartdisponibilite.update();
        this.addCenterCircleAndText(
          this.$refs.myChartContainer3,
          this.liste_dashboard.disponibilite_parc
        );
      }
      // Calculate total alarms

      let majorAlarms = this.major_alarms || 0;
      let minorAlarms = this.minor_alarms || 0;
      let withoutAlarms = this.total;
      let totalAlarms = withoutAlarms + majorAlarms + minorAlarms;

      // Default to zero if no alarms
      let nbrWithout =
        totalAlarms > 0 ? (withoutAlarms / totalAlarms) * 100 : 0;
      let nbrMajor = totalAlarms > 0 ? (majorAlarms / totalAlarms) * 100 : 0;
      let nbrMinor = totalAlarms > 0 ? (minorAlarms / totalAlarms) * 100 : 0;

      // Update the alarms chart
      if (this.chartalarmes) {
        this.chartalarmes.data.datasets[0].data[0] = nbrWithout;
        this.chartalarmes.data.datasets[0].data[1] = nbrMinor;
        this.chartalarmes.data.datasets[0].data[2] = nbrMajor;
        this.chartalarmes.update();
      }

      // Update the clean park chart
      if (this.chartpr) {
        this.chartpr.data.datasets[0].data[0] =
          this.liste_dashboard.pr_clean_parc;
        this.chartpr.data.datasets[0].data[1] =
          100 - this.liste_dashboard.pr_clean_parc;
        this.chartpr.update();
        this.addCenterCircleAndTextgreen(
          this.$refs.myChartContainer1,
          this.liste_dashboard.pr_clean_parc
        );
      }
    },
  },
};
</script>

<style>
.titledashboard {
  margin-left: 10px;
  font-size: 13px;
  font-weight: bold;
}
.containerdashboard {
  flex: 1;
  border-left: 1px solid black;
}

.containerdashboardtwo {
  flex: 1;
  border-left: 3px solid black;
}

.dashboard-content {
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
  margin-left: 10px;
}

.icon-container {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}

.treeview-container {
  max-height: 300px;
  overflow-y: auto;
}
.v-menu__content {
  min-width: 350px !important;
}

.icon-item {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.icon-label {
  margin-left: 5px;
  font-size: 13px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
}

.graph {
  width: 100%;
  max-width: 125px;
  margin-top: 15px;
  margin-bottom: 5px;
  margin-left: 15px;
}

.custom-nudge {
  position: relative;
  left: 101%;
  top: -78px;
}
</style>
